import React, { PureComponent } from 'react'
import cn from 'classnames'

export const BadgeKinds = {
  DEFAULT: 'default',
  DIM: 'dim',
  TRANSPARENT: 'transparent',
  PRIMARY: 'primary',
  UTILITY: 'utility',
  ANNOUNCE: 'announce',
  URGENCY: 'urgency',
} as const

export type BadgeKindValue = (typeof BadgeKinds)[keyof typeof BadgeKinds]

interface BadgeProps
  extends React.PropsWithChildren<React.HTMLProps<HTMLElement>> {
  kind?: BadgeKindValue
}

export default class Badge extends PureComponent<BadgeProps> {
  static defaultProps = {
    kind: 'default',
  }

  render() {
    const { children, className, kind, ...props } = this.props

    const classNames = cn({
      'mc-badge mc-text-x-small': true,
      [`mc-badge--${kind}`]: kind,
      [className ?? '']: className,
    })

    return (
      <span className={classNames} {...props}>
        {children}
      </span>
    )
  }
}
